import { getVehicleEquipment } from '../../server/api/mappers/vehicles.helpers';

/**
 * Volkswagen
 *
 * ```
 *     State:   Sold - Seller confirmed
 *    Images:   Yes
 *      Bids:   1
 * User bids:   0
 *    Mapper:   No
 * ```
 */
export default () => {
	const vehicle = {
		additionalDetails: 'Windscreen is being fixed within a week - car available from 25/06',
		additionalSpec:
			'Keyless Entry\nKeyless Go, \nMetallic Upgraded paid,\nParking sensors,\nBluetooth,\nApple car play / Android,\nAuto Folding Wing Mirrors,\nLED Lights\nPaddle Shifts',
		additionalSpecV2: {
			items: [
				{ name: 'Jet boosters', price: 123 },
				{ name: 'Mirror dice', price: 69 },
			],
			totalCost: 192,
		},
		availableFrom: '2020-06-25T00:00:00.000Z',
		availableUntil: null,
		bids: {
			activeBidCount: 1,
			usersBids: [],
		},
		dentsDesc: null,
		displayPrice: 16200,
		equipment: 'sat_nav,parking_cam,sound_system',
		exteriorGrade: 'bronze',
		hasDents: false,
		hasLockingWheelNut: true,
		hasMissingParts: true,
		hasOtherContactActiveBid: false,
		hasPaintProblems: true,
		hasPrivatePlate: false,
		hasScratches: false,
		hasScuffedAlloy: true,
		hasServiceRecords: true,
		hasToolsInBoot: true,
		hasWarningLights: false,
		hasWindscreenProblems: null,
		id: 403677,
		independentServiceStampsCount: 0,
		interiorType: 'Suede',
		isTrade: false,
		isVatQualifying: null,
		isVehicleOnFinance: false,
		keeperStartDate: '2018-05-09T00:00:00.000Z',
		keysCount: 2,
		lastMOTDate: null,
		mileage: 29800,
		minimumBid: {
			type: 'offer',
			value: 5000,
		},
		missingPartsDesc: 'Arm rest - centre console - potential burn',
		officialServiceStampsCount: 1,
		paintProblemsDesc: 'minor chip left side wheel arch - stone chip',
		prettyVrm: 'EY18 HUJ',
		previousKeepersCount: null,
		scratchesDesc: null,
		scuffedAlloyDesc: '3',
		seller: {
			distance: 16,
			town: 'Buckhurst Hill',
		},
		sellerWillAcceptPrice: 16200,
		serviceHistory: 'yes',
		soldDate: '2020-06-16T15:03:59.650Z',
		soldFor: 15200,
		spec: {
			body: 'Hatchback',
			bodyCategory: 'Hatchback',
			colour: 'Blue',
			engineSize: 1498,
			firstRegistered: '2018-05-09T00:00:00.000Z',
			fuel: 'Petrol',
			make: 'Volkswagen',
			model: 'Golf R Line TSI EVO S-A',
			transmission: 'Automatic',
			vin: 'WVWZZZAUZJW238769',
		},
		state: {
			category: 'sold',
			id: 50,
			name: 'Sold - Seller confirmed',
			slug: 'sold_confirmed',
		},
		tyreProblemsDesc: null,
		vehicleImages: [
			{
				createdAt: '2020-06-15T12:57:04.194Z',
				enquiryId: 403677,
				id: 646452,
				kind: 'exterior_front_driver',
				meta: {
					canvas: {
						height: 903,
						left: 1,
						naturalHeight: 1339,
						naturalWidth: 1785,
						top: 0,
						width: 1204,
					},
					cropBox: {
						height: 748,
						left: 64,
						top: 0,
						width: 998,
					},
					height: 1109,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1479,
					x: 94,
					y: 0,
				},
				source: 'motorway-agent-webapp:e110c6a921b4e9aea7592b0ee9de9a53f52aae13',
				url: 'https://motorway.imgix.net/3677/403677/exterior_front_driver-1592225822826.jpg',
			},
			{
				createdAt: '2020-06-15T13:23:47.895Z',
				enquiryId: 403677,
				id: 646578,
				kind: 'exterior_rear_driver',
				meta: {
					canvas: {
						height: 903,
						left: 0,
						naturalHeight: 1600,
						naturalWidth: 1200,
						top: 0,
						width: 677,
					},
					cropBox: {
						height: 482,
						left: 22,
						top: 128,
						width: 642,
					},
					height: 854,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1138,
					x: 38,
					y: 227,
				},
				source: 'motorway-agent-webapp:e110c6a921b4e9aea7592b0ee9de9a53f52aae13',
				url: 'https://motorway.imgix.net/3677/403677/exterior_rear_driver-1592227426567.jpg',
			},
			{
				createdAt: '2020-06-15T10:24:23.649Z',
				enquiryId: 403677,
				id: 645502,
				kind: 'exterior_front_passenger',
				meta: {
					canvas: {
						height: 1084,
						left: -120,
						naturalHeight: 1200,
						naturalWidth: 1600,
						top: -90,
						width: 1445,
					},
					cropBox: {
						height: 740,
						left: 148,
						top: 44,
						width: 987,
					},
					height: 819,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1093,
					x: 297,
					y: 149,
				},
				source: 'motorway-agent-webapp:e110c6a921b4e9aea7592b0ee9de9a53f52aae13',
				url: 'https://motorway.imgix.net/3677/403677/exterior_front_passenger-1592216662703.jpg',
			},
			{
				createdAt: '2020-06-15T14:28:56.557Z',
				enquiryId: 403677,
				id: 647057,
				kind: 'exterior_rear_passenger',
				meta: {
					canvas: {
						height: 903,
						left: 0,
						naturalHeight: 1600,
						naturalWidth: 1200,
						top: 0,
						width: 677,
					},
					cropBox: {
						height: 474,
						left: 17,
						top: 7,
						width: 632,
					},
					height: 840,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1119,
					x: 30,
					y: 12,
				},
				source: 'motorway-agent-webapp:e110c6a921b4e9aea7592b0ee9de9a53f52aae13',
				url: 'https://motorway.imgix.net/3677/403677/exterior_rear_passenger-1592231335861.jpg',
			},
			{
				createdAt: '2020-06-08T13:45:19.135Z',
				enquiryId: 403677,
				id: 622711,
				kind: 'interior_front_seats',
				meta: {
					canvas: {
						height: 505,
						left: 282,
						naturalHeight: 4032,
						naturalWidth: 3024,
						top: 376,
						width: 379,
					},
					cropBox: {
						height: 509,
						left: 0,
						top: 379,
						width: 678,
					},
					height: 4057,
					rotate: '90',
					scaleX: 1,
					scaleY: 1,
					width: 5410,
					x: 0,
					y: 24,
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/interior_front_seats-1591623913373.jpg',
			},
			{
				createdAt: '2020-06-15T10:24:13.140Z',
				enquiryId: 403677,
				id: 645500,
				kind: 'interior_rear_seats',
				meta: {
					canvas: {
						height: 607,
						left: 244,
						naturalHeight: 1600,
						naturalWidth: 1200,
						top: 326,
						width: 455,
					},
					cropBox: {
						height: 486,
						left: 30,
						top: 320,
						width: 648,
					},
					height: 1282,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1709,
					x: 0,
					y: 0,
				},
				source: 'motorway-agent-webapp:e110c6a921b4e9aea7592b0ee9de9a53f52aae13',
				url: 'https://motorway.imgix.net/3677/403677/interior_rear_seats-1592216652311.jpg',
			},
			{
				createdAt: '2020-06-08T13:49:35.612Z',
				enquiryId: 403677,
				id: 622747,
				kind: 'interior_dashboard',
				meta: {
					canvas: {
						height: 962,
						left: 0,
						naturalHeight: 3024,
						naturalWidth: 4032,
						top: 0,
						width: 1283,
					},
					cropBox: {
						height: 714,
						left: 253,
						top: 120,
						width: 952,
					},
					height: 2243,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 2992,
					x: 795,
					y: 376,
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/interior_dashboard-1591624171416.jpg',
			},
			{
				createdAt: '2020-06-08T13:50:35.287Z',
				enquiryId: 403677,
				id: 622752,
				kind: 'wheels_front_driver',
				meta: {
					canvas: {
						height: 963,
						left: 0,
						naturalHeight: 4032,
						naturalWidth: 3024,
						top: 0,
						width: 722,
					},
					cropBox: {
						height: 527,
						left: 19,
						top: 223,
						width: 702,
					},
					height: 2205,
					rotate: '90',
					scaleX: 1,
					scaleY: 1,
					width: 2940,
					x: 80,
					y: 932,
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/wheels_front_driver-1591624230224.jpg',
			},
			{
				createdAt: '2020-06-08T13:50:52.629Z',
				enquiryId: 403677,
				id: 622754,
				kind: 'wheels_rear_driver',
				meta: {
					canvas: {
						height: 963,
						left: 0,
						naturalHeight: 4032,
						naturalWidth: 3024,
						top: 0,
						width: 722,
					},
					cropBox: {
						height: 488,
						left: 9,
						top: 154,
						width: 651,
					},
					height: 2045,
					rotate: '90',
					scaleX: 1,
					scaleY: 1,
					width: 2727,
					x: 39,
					y: 644,
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/wheels_rear_driver-1591624248277.jpg',
			},
			{
				createdAt: '2020-06-08T13:51:19.276Z',
				enquiryId: 403677,
				id: 622757,
				kind: 'wheels_front_passenger',
				meta: {
					canvas: {
						height: 962,
						left: 0,
						naturalHeight: 3024,
						naturalWidth: 4032,
						top: 0,
						width: 1283,
					},
					cropBox: {
						height: 770,
						left: 164,
						top: 92,
						width: 1026,
					},
					height: 2419,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 3226,
					x: 516,
					y: 288,
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/wheels_front_passenger-1591624273675.jpg',
			},
			{
				createdAt: '2020-06-08T13:51:27.411Z',
				enquiryId: 403677,
				id: 622759,
				kind: 'wheels_rear_passenger',
				meta: {
					canvas: {
						height: 962,
						left: 0,
						naturalHeight: 3024,
						naturalWidth: 4032,
						top: 0,
						width: 1283,
					},
					cropBox: {
						height: 770,
						left: 154,
						top: 50,
						width: 1026,
					},
					height: 2419,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 3226,
					x: 483,
					y: 156,
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/wheels_rear_passenger-1591624283042.jpg',
			},
			{
				createdAt: '2020-06-08T13:52:50.526Z',
				enquiryId: 403677,
				id: 622762,
				kind: 'tyre_tread_front_driver',
				meta: {
					canvas: {
						height: 903,
						left: 0,
						naturalHeight: 4032,
						naturalWidth: 3024,
						top: 0,
						width: 677,
					},
					cropBox: {
						height: 406,
						left: 67,
						top: 10,
						width: 542,
					},
					height: 1814,
					rotate: '90',
					scaleX: 1,
					scaleY: 1,
					width: 2419,
					x: 296,
					y: 44,
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/tyre_tread_front_driver-1591624363829.jpg',
			},
			{
				createdAt: '2020-06-08T13:53:31.237Z',
				enquiryId: 403677,
				id: 622772,
				kind: 'tyre_tread_rear_driver',
				meta: {
					canvas: {
						height: 963,
						left: 0,
						naturalHeight: 4032,
						naturalWidth: 3024,
						top: 0,
						width: 722,
					},
					cropBox: {
						height: 433,
						left: 0,
						top: 50,
						width: 578,
					},
					height: 1815,
					rotate: '90',
					scaleX: 1,
					scaleY: 1,
					width: 2419,
					x: 0,
					y: 210,
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/tyre_tread_rear_driver-1591624406148.jpg',
			},
			{
				createdAt: '2020-06-08T13:53:05.522Z',
				enquiryId: 403677,
				id: 622767,
				kind: 'tyre_tread_front_passenger',
				meta: {
					canvas: {
						height: 963,
						left: 0,
						naturalHeight: 4032,
						naturalWidth: 3024,
						top: 0,
						width: 722,
					},
					cropBox: {
						height: 433,
						left: 48,
						top: 14,
						width: 578,
					},
					height: 1814,
					rotate: '90',
					scaleX: 1,
					scaleY: 1,
					width: 2419,
					x: 202,
					y: 56,
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/tyre_tread_front_passenger-1591624379216.jpg',
			},
			{
				createdAt: '2020-06-08T13:53:46.931Z',
				enquiryId: 403677,
				id: 622773,
				kind: 'tyre_tread_rear_passenger',
				meta: {
					canvas: {
						height: 963,
						left: 0,
						naturalHeight: 4032,
						naturalWidth: 3024,
						top: 0,
						width: 722,
					},
					cropBox: {
						height: 433,
						left: 0,
						top: 0,
						width: 578,
					},
					height: 1815,
					rotate: '90',
					scaleX: 1,
					scaleY: 1,
					width: 2419,
					x: 0,
					y: 0,
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/tyre_tread_rear_passenger-1591624419974.jpg',
			},
			{
				createdAt: '2020-06-15T12:56:02.224Z',
				enquiryId: 403677,
				id: 646449,
				kind: 'damage_paintwork',
				meta: {
					height: 675,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 900,
					x: 0,
					y: 463,
				},
				source: 'motorway-agent-webapp:e110c6a921b4e9aea7592b0ee9de9a53f52aae13',
				url: 'https://motorway.imgix.net/3677/403677/damage_paintwork-0-1592225761579.jpg',
			},
			{
				createdAt: '2020-06-15T12:56:10.256Z',
				enquiryId: 403677,
				id: 646451,
				kind: 'damage_missing_trims',
				meta: {
					height: 675,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 900,
					x: 0,
					y: 463,
				},
				source: 'motorway-agent-webapp:e110c6a921b4e9aea7592b0ee9de9a53f52aae13',
				url: 'https://motorway.imgix.net/3677/403677/damage_missing_trims-0-1592225769478.jpg',
			},
			{
				createdAt: '2020-06-08T13:54:06.173Z',
				enquiryId: 403677,
				id: 622778,
				kind: 'damage_alloy_scuffs',
				meta: {
					height: '3024',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '4032',
					x: '0',
					y: '0',
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/damage_alloy_scuffs-1591624439510.jpg',
			},
			{
				createdAt: '2020-06-08T13:54:57.167Z',
				enquiryId: 403677,
				id: 622794,
				kind: 'damage_alloy_scuffs',
				meta: {
					height: '3024',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '4032',
					x: '0',
					y: '0',
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/damage_alloy_scuffs-2-1591624490205.jpg',
			},
			{
				createdAt: '2020-06-08T13:54:43.000Z',
				enquiryId: 403677,
				id: 622789,
				kind: 'damage_alloy_scuffs',
				meta: {
					height: '2268',
					rotate: '270',
					scaleX: '1',
					scaleY: '1',
					width: '3024',
					x: '0',
					y: '882',
				},
				source: 'motorway-seller-webapp:8e2c46dc586881c908ffc62f0f645b162213b35a',
				url: 'https://motorway.imgix.net/3677/403677/damage_alloy_scuffs-1-1591624475751.jpg',
			},
		],
		vrm: 'EY18HUJ',
		warningLightsDesc: null,
		windscreenProblemsDesc: null,
		year: 2018,
	};

	return {
		...vehicle,
		equipmentV2: getVehicleEquipment(vehicle),
	};
};
